import { Box, Typography, Grid, Container } from "@mui/material";

const stats = [
  {
    value: "500+",
    label: "Sales Professionals Trained",
  },
  {
    value: "₹50Cr+",
    label: "Revenue Generated",
  },
  {
    value: "15+",
    label: "Industries Served",
  },
];

const PremiumSalesSection = () => {
  return (
    <Box
      sx={{
        py: 5,
        px: { xs: 2, md: 6 },

        // ✅ TRANSPARENT BG (IMPORTANT)
        background: "transparent",
          
        // background: "linear-gradient(135deg, rgba(15, 99, 165, 0.3) 0%, rgba(10, 22, 40, 0.6) 100%)",
        color: "#fff",
      }}
    >
      {/* CONTENT WRAPPER */}
  <Container maxWidth="xl" sx={{ px: { xs: 2, md: 10 } }}>

            {/* 🔥 HEADING */}
            <Typography
            variant="h3"
            sx={{
                
                fontSize: { xs: "2rem", md: "3rem" },
                fontWeight: 400,
                letterSpacing: "2px",
                mb: 3,
                color: "white",
            }}
            >
            Premium Sales Excellence
            </Typography>

            {/* 🔥 DESCRIPTION */}
            <Typography
            sx={{
                color: "rgba(255,255,255,0.8)",
                
                lineHeight: 1.8,
                fontSize: { xs: "0.9rem", md: "1.05rem" },
                mb: 6,
                textAlign:'center'
            }}
            >
            We partner with elite sales professionals and organizations across luxury industries—Real Estate, Automobiles,
            Watches, Interiors, and beyond. Our methodology combines deep psychological insight, market-tested strategies,
            and real-world execution to transform how you sell.
            </Typography>

            {/* 🔥 STATS CARDS */}
            <Grid container spacing={4}>
            {stats.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                <Box
                    sx={{
                    p: 4,
                    borderRadius: "12px",

                    // 🔥 TRANSPARENT GLASS CARD
                    background: "rgba(255,255,255,0.03)",
                    backdropFilter: "blur(6px)",

                    border: "1px solid rgba(255,255,255,0.1)",

                    transition: "all 0.4s ease",

                    "&:hover": {
                        transform: "translateY(-6px)",
                        borderColor: "rgba(250, 249, 246, 0.9)",
                    },
                    }}
                >
                    {/* VALUE */}
                    <Typography
                    sx={{
                        color: "#0f63a5", // gold
                        fontSize: { xs: "1.8rem", md: "2.4rem" },
                        fontWeight: 600,
                        mb: 1,
                        fontFamily: "Playfair Display, serif !important",
                    }}
                    >
                    {item.value}
                    </Typography>

                    {/* LABEL */}
                    <Typography
                    sx={{
                        color: "rgba(255,255,255,0.7)",
                        fontSize: "0.95rem",
                        letterSpacing: "0.5px",
                    }}
                    >
                    {item.label}
                    </Typography>
                </Box>
                </Grid>
            ))}
            </Grid>
  </Container>
        
      </Box>
    
  );
};

export default PremiumSalesSection;